import * as React from 'react'

type Props = {
  webpSrc: string
  imgSrc: string
  style: React.CSSProperties
  pictureStyle: React.CSSProperties
  pictureClassName?: string
  sourceStyle: React.CSSProperties
  imgStyle: React.CSSProperties
  sourceProps: JSX.IntrinsicElements['source']
  imgProps: JSX.IntrinsicElements['img']
  className: string
}

/**
 * allow webp image component
 */
const Component: React.FC<Partial<Props>> = ({
  webpSrc = null,
  imgSrc = null,
  style = {},
  pictureStyle = {},
  pictureClassName = '',
  sourceStyle = {},
  imgStyle = {},
  sourceProps = {},
  imgProps = {},
  className = '',
}) => {
  return (
    <picture style={{ ...pictureStyle }} className={pictureClassName}>
      {webpSrc && (
        <source
          srcSet={webpSrc}
          type="image/webp"
          style={{ ...style, ...sourceStyle }}
          className={className}
          {...sourceProps}
        />
      )}
      {imgSrc && (
        <img
          src={imgSrc}
          style={{ ...style, ...imgStyle }}
          className={className}
          {...imgProps}
        />
      )}
    </picture>
  )
}

export default Component
